module.exports = __webpack_public_path__ + "static/media/learn-trophy-icon.059996cf.svg";